<template>
<div class="create-delivery">

  <vue-headful
    title="TZ Design Box - Create Delivery Adress"
    description="TZ Design Box"
/>

  <div class="container">
    <div class="columns">
      <div class="column is-2 menu-vert">
        <MenuVert :currentactive="'create-delivery'" />
      </div>
      <div class="column is-10" style="margin-top:25px;">
        <Breadcrumbs/>
        <hr>
        <div class="content">
          <h2>{{ $t("create-delivery") }}</h2>
          <p>{{ $t("delivery-create-details") }}</p>
          <form @submit.prevent="validateBeforeSubmit">
            <b-field grouped>
              <b-field expanded :label="$t('name1')"
                :type="{'is-danger': errors.has('name1')}"
                :message="errors.first('name1')">
                <b-input v-model="delivery.name1" name="name1" v-validate="'required'" />
              </b-field>
              <b-field expanded :label="$t('name2')"
                :type="{'is-danger': errors.has('name2')}"
                :message="errors.first('name2')">
                <b-input v-model="delivery.name2" name="Name2" />
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field expanded :label="$t('address1')">
                <b-input v-model="delivery.address1" name="address1" v-validate="'required'"  />
              </b-field>
              <b-field expanded :label="$t('address2')">
                <b-input v-model="delivery.address2" name="address2" />
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field expanded :label="$t('zip')">
                <b-input v-model="delivery.zip" name="zip" v-validate="'required'"  />
              </b-field>
              <b-field expanded :label="$t('city')">
                <b-input v-model="delivery.city" name="city" v-validate="'required'"  />
              </b-field>
              <b-field expanded :label="$t('country')" >
                <b-select name="country" v-model="delivery.country" v-validate="'required'" >
                  <option v-for="country in companyCountry"
                          :value="country[0]"
                          :key="country[0]">
                          {{ country[1] }}
                      </option>
                </b-select>
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field expanded :label="$t('phone')"
                :type="{'is-danger': errors.has('phone')}"
                :message="errors.first('phone')">
                <b-input v-model="delivery.phone" name="phone" v-validate="'required'" />
              </b-field>
              <b-field expanded :label="$t('mobilephone')"
                :type="{'is-danger': errors.has('mobile')}"
                :message="errors.first('mobile')">
                <b-input v-model="delivery.mobile" name="mobile" />
              </b-field>
              <b-field :label="$t('email')"
                :type="{'is-danger': errors.has('email')}"
                :message="errors.first('email')">
                <b-input v-model="delivery.email" name="email" v-validate="'email'"  />
              </b-field>
            </b-field>

            <b-button native-type="submit" type="is-primary" :loading="saveDeliveryActive">{{ $t("save") }}</b-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MenuVert           from '@/components/MenuVert'
import Breadcrumbs        from '@/components/Breadcrumbs'
import { mapGetters }     from 'vuex'

export default{
    name: 'Createdelivery',
    computed: {
        ...mapGetters ([
          'getCurrentCompany',
          'getCountryCodesAdress',
          "saveDeliveryActive",
          "getCompany"
          ]),
        cid: {
            get () { return this.getCompany}
        },
    },
    data: function(){
        return{
            delivery:{},
            companyCountry: []
        }
    },
    components: {MenuVert, Breadcrumbs},
    methods: {
        validateBeforeSubmit() {
            var self=this
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.$store.dispatch("createDeliveryAdress",{delivery:this.delivery,cid:this.cid,self:self})
                    .catch((error) =>{
                        self.$toastr('error', error, 'Failure')
                    })
                    return
                }
            })
        }
    },
    mounted(){
        var self = this
        console.log ("FOOBAR", this.getCurrentCompany)
        this.$store.dispatch("callDeliveryAdresses",{self:self,company:this.cid})
        this.$store.dispatch ("callCurrentCompany", {self:this,company:this.cid}).then (() => {
          //this.delivery.country = this.getCurrentCompany.country [0]
          this.companyCountry = [this.getCurrentCompany.country]
          Vue.set (this.delivery, "country", this.getCurrentCompany.country [0])
        })
    }
}
</script>

<style>
.create-delivery{
    padding-bottom:50px;
}
.content{
    background-color:#fff!important;
    padding:25px;
    box-shadow: 0 1px #FFFFFF inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}
</style>
